import React from "react";
import classes from "./NavbarMobile2.module.css";
import { useNavigate } from "react-router-dom";

const NavbarMobile2 = () => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(-1);
  };
  return (
    <nav className={classes.mobile_navbar}>
      {/* back icon */}
      <button className={classes.back_button} onClick={handleNavigate}>
        <i className={`pi pi-arrow-left ${classes.back_icon}`} />
      </button>
      {/* <div className={classes.nav_buttons_container}>
        <i className={`${classes.icon} pi pi-heart`} />

        <i className={`${classes.icon} pi pi-bookmark`} />
      </div> */}
    </nav>
  );
};

export default NavbarMobile2;
